import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const csmExperienceMessagingAppsWhatsappRoute: InvariantJiraRoute = {
	name: 'csm-experience-messaging-apps-whatsapp',
	path: '/jira/customer-service-management/experiences/:projectKey/settings/:helpCenterId/messaging-apps/whatsapp',
	exact: true,
};
